import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-sand flex items-center justify-center p-6">
      <div className="bg-white border border-sand-border rounded-2xl p-10 max-w-md w-full text-center shadow-sm" data-testid="payment-cancel-page">
        <div className="w-16 h-16 rounded-full bg-red-50 border border-red-200 flex items-center justify-center mx-auto">
          <XCircle className="w-8 h-8 text-red-500" />
        </div>
        <h1 className="font-serif text-2xl text-slate-900 mt-5">Payment Cancelled</h1>
        <p className="text-sm text-muted-foreground mt-2">Bayaran dibatalkan. Tiada caj dikenakan. / Payment cancelled. No charge was made.</p>
        <Link to="/app/portal" data-testid="cancel-back-to-portal-link"
          className="inline-block mt-6 px-6 py-2.5 rounded-full bg-emerald-800 hover:bg-emerald-700 text-white text-sm font-semibold transition-colors">
          Back to Portal
        </Link>
      </div>
    </div>
  );
}
